import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import firebaseConfig from '../firebase-config';

let analytics;

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

// Initialize Firebase for Web
analytics = firebase.analytics();

const setCurrentScreen = async ({ screenName }) => {
  if (Capacitor.isNativePlatform()) {
    await FirebaseAnalytics.setCurrentScreen({
      screenName: screenName,
      //  screenClassOverride: screenClass,
    });
  } else {
    analytics.logEvent('screen_view', {
      firebase_screen: screenName,
      // firebase_screen_class: screenClass,
    });
  }
};

const logEvent = async (name, params) => {
  if (Capacitor.isNativePlatform()) {
    await FirebaseAnalytics.logEvent({
      name,
      params,
    });
  } else {
    analytics.logEvent(name, params);
  }
};

export default { setCurrentScreen, logEvent };
